const ActionConstants = {
  MATCH_MEDIA: 'MATCH_MEDIA'
}
export default {
  ActionConstants,
  reducerName: 'mediaQuery'
}



// WEBPACK FOOTER //
// ./src/redux-modules/media-query/MediaQueryConstants.js